var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("h6", [
          _vm._v("Новая заявка\n        "),
          !_vm.createOpen
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-primary",
                  on: {
                    click: function ($event) {
                      _vm.createOpen = !_vm.createOpen
                    },
                  },
                },
                [_vm._v("Создать")]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.createOpen
        ? _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("newOrderSmallForm", {
                attrs: {
                  orderUpdated: _vm.orderUpdated,
                  rates: _vm.rates,
                  byAgentReSeller: true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c(
          "h5",
          [
            _vm._v("Заявки для обработки "),
            _vm.confirmOrders.length
              ? _c("strong", [
                  _vm._v("(" + _vm._s(_vm.confirmOrders.length) + ")"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "vue-ladda",
              {
                attrs: {
                  "button-class": "btn btn-sm btn-success pull-right",
                  "data-style": "zoom-in",
                  loading: _vm.searchLoading,
                },
                on: { click: _vm.search },
              },
              [_vm._v("Обновить\n        ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _vm.searchLoading
          ? _c(
              "div",
              { staticClass: "text-center m-t-20" },
              [
                _c("pulse-loader", {
                  attrs: {
                    loading: _vm.searchLoading,
                    color: _vm.loadingColor,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.confirmOrders.length
          ? _c("div", [
              _c(
                "div",
                [
                  _c("ordersEditList", {
                    ref: "orderList",
                    attrs: {
                      rates: _vm.rates,
                      orders: _vm.confirmOrders,
                      viewType: "confirm",
                      updateOrderDetails: _vm.updateOrderDetails,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      { staticClass: "form-group w-50 pr-3" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Дата планируемой доставки (в Москве)"),
                        ]),
                        _vm._v(" "),
                        _c("datetime", {
                          attrs: {
                            "input-class": "form-control",
                            type: "date",
                            "minute-step": 60,
                            format: "dd.MM.yyyy (cccc)",
                            auto: true,
                            "min-datetime": _vm.minDateSelect,
                            "max-datetime": _vm.maxDateSelect,
                          },
                          model: {
                            value: _vm.deliveryDate,
                            callback: function ($$v) {
                              _vm.deliveryDate = $$v
                            },
                            expression: "deliveryDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group w-100" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Адрес доставки (в Москве)"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.address,
                            expression: "address",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Адрес доставки" },
                        domProps: { value: _vm.address },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.address = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("label", [
                        _vm._v("Дополнительные препараты (по необходимости)"),
                      ]),
                      _vm._v(" "),
                      _c("DrugSearchNew", {
                        ref: "searchExtraDrug",
                        attrs: { onSelect: _vm.addExtraDrug },
                      }),
                      _vm._v(" "),
                      _vm.extraDrugs.length
                        ? _c(
                            "table",
                            {
                              staticClass:
                                "table mt-0 table-sm table-hover table-small-td",
                            },
                            [
                              _c(
                                "tbody",
                                _vm._l(_vm.extraDrugs, function (d, i) {
                                  return _c("tr", [
                                    _c("td", [_vm._v(_vm._s(i + 1))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(d.title))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: d.qty,
                                            expression: "d.qty",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "number",
                                          placeholder: "количество",
                                        },
                                        domProps: { value: d.qty },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              d,
                                              "qty",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-danger btn-sm",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              _vm.extraDrugs =
                                                _vm.extraDrugs.filter(
                                                  (dd) => dd.id !== d.id
                                                )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-trash",
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ])
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-sm pull-right btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.loadingBtn,
                      },
                      on: { click: _vm.createOneOrder },
                    },
                    [_vm._v("Отправить на сборку выбранные заявки\n          ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _vm.paginator
                    ? _c("paginate", {
                        attrs: {
                          "page-count": _vm.paginator.last_page,
                          "page-range": 3,
                          "margin-pages": 2,
                          "click-handler": _vm.search,
                          "prev-text": "&laquo",
                          "next-text": "&raquo",
                          "container-class": "pagination",
                          "prev-class": "page-item",
                          "prev-link-class": "page-link",
                          "page-class": "page-item",
                          "page-link-class": "page-link",
                          "next-class": "page-item",
                          "next-link-class": "page-link",
                          "active-class": "active green_btn",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c("h5", [
          _vm._v(
            "Заявки на доставку (" + _vm._s(_vm.collectedOrders.length) + ")"
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.collectedOrders.length
        ? _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("ordersEditList", {
                ref: "moderatingOrders",
                attrs: {
                  rates: _vm.rates,
                  orders: _vm.collectedOrders,
                  viewType: "collectedOrders",
                  supplyOrders: _vm.supplyOrders,
                  updateOrderDetails: _vm.updateOrderDetails,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header" }, [
        _c(
          "h5",
          [
            _vm._v(
              "Заявки на модерации (" +
                _vm._s(_vm.moderatingOrders.length) +
                ")\n        "
            ),
            _vm.moderatingOrders.length
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary pull-right",
                      on: {
                        click: function ($event) {
                          _vm.moderateOpen = !_vm.moderateOpen
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.moderateOpen ? "Скрыть" : "Показать") +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.moderateOpen && _vm.moderatingOrders.length
        ? _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("ordersEditList", {
                ref: "moderatingOrders",
                attrs: {
                  rates: _vm.rates,
                  orders: _vm.moderatingOrders,
                  viewType: "moderating",
                  updateOrderDetails: _vm.updateOrderDetails,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }